import EcommerceAPI from 'api/ecommerce'

const redirectToShopify = async (dispatch, state) => {
  const { temporaryRecord: { pluginEcommerce } } = state

  try {
    const { data } = await EcommerceAPI.getShopifyURL(
      {
        domain: pluginEcommerce?.value?.domain,
        key: 'shopify',
        enabledModule: true
      }
    )

    window.location.replace(data.url)
  } catch(error) {
    console.error('redirect shopify', error)
  }
}

export default {
  redirect_shop_ecommerce: {
    shopify: redirectToShopify
  }
}
